<script setup lang="ts">
import ElMessageBoxVnode from "./ElMessageBoxVnode.vue";
import { h, watch } from "vue";
import { showMessageBox, messageBoxContent } from "./messageBox";

const openElMessageBox = () => {
  ElMessageBox({
    message: h(ElMessageBoxVnode),
    showConfirmButton: false,
    customClass: "csd-el-message-box",
    callback: () => {
      showMessageBox.value = false;
      messageBoxContent.value.cancel();
    },
  });
};

watch(showMessageBox, () => {
  if (showMessageBox.value) {
    openElMessageBox();
  } else {
    ElMessageBox.close();
  }
});
</script>

<template>
  <div></div>
</template>

<style lang="scss">
.csd-el-message-box {
  padding: 0 !important;
  .el-message-box__content {
    padding: 0;
  }
  .el-message-box__btns {
    padding: 0;
  }
}
</style>
